import React, { useState, createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

const AuthContext = createContext(null);

const mockLogin = async (username, password) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(checkCredentials(username, password));
    }, 300);
  });
};
const checkCredentials = (username, password) => {
  if (username === 'admin' && password === 'admin') {
    return 'Logged In';
  } else {
    throw new Error('Invalid credentials');
  }
};

const mockLogout = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve('The user has successfully logged on the server');
    }, 300);
  });
};

const handleLoginResult = (setLogin) => (result) => {
  if (result) {
    setLogin(true);
  }
};

const handleLoginError = () => (error) => {
  toast.error('Authentication failed');
  throw error;
};

const handleLogoutResult = (setLogin) => (result) => {
  if (result) {
    setLogin(false);
  }
};

const handleLogoutError = () => (error) => {
  toast.error('Logout failed');
  throw error;
};

const AuthProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(false);

  const login = async (username, password) => {
    try {
      const result = await mockLogin(username, password);
      handleLoginResult(setLoggedIn)(result);
    } catch (error) {
      handleLoginError()(error);
    }
  };

  const logout = async () => {
    try {
      const result = await mockLogout();
      handleLogoutResult(setLoggedIn)(result);
    } catch (error) {
      handleLogoutError()(error);
    }
  };

  const authContextValue = useMemo(
    () => ({ loggedIn, setLoggedIn, login, logout }),
    [loggedIn],
  );

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { AuthContext, AuthProvider };
